import React from 'react'
import BallsBackground from '../BallsBackground'

function Steps({ children }) {
    return (
        <BallsBackground>
            <div className="content container shadow1">
                <div className="progress-bar">
                    <div className="progress"></div>
                    <div className="step active">
                        <div className="title">
                            <div className="number"><span>1</span></div>
                            <p>Your profile</p>
                        </div>
                    </div>
                    <div className="step">
                        <div className="title">
                            <div className="number"><span>2</span></div>
                            <p>Agreements</p>
                        </div>
                    </div>
                    <div className="step">
                        <div className="title">
                            <div className="number"><span>3</span></div>
                            <p>Documents</p>
                        </div>
                    </div>
                </div>
                <div className="inner-content">
                    <div className="heading">
                        <p className="subtitle">Step 1</p>
                        <h1 className="title">Your profile</h1>
                        <p className="description">Enter your information to register</p>
                    </div>
                    {children}
                </div>
            </div>
        </BallsBackground>
    )
}

export default Steps